export default __webpack_public_path__ + "d372ce1e00f388873d7da32a7a62412f.svg";